/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    ICreateActionContext
} from '@msdyn365-commerce/core';

import { getWarehouseStockAvailQtyAsync } from './DataService/DataActionExtension.g';
import { IGetWarehouseStockAvailQtyResponse } from './DataService/DataServiceEntities.g';

/**
 * GetWarehouseStockAvailQty Input Action
 */
export class GetWarehouseStockAvailQtyInput implements IActionInput {
    // Input properties
    public itemId: string;
    public accountNum: number;
    public itemQuantity: string;
    public userName: string;

    constructor(itemId: string, accountNum: number | string, itemQuantity: string, userName: string) {
        this.itemId = itemId;
        this.accountNum = typeof accountNum === 'string' ? +accountNum : accountNum;
        this.itemQuantity = itemQuantity;
        this.userName = userName;
    }

    public getCacheKey = () => `GetWarehouseStockAvailQtyInput`;
    public getCacheObjectType = () => 'GetWarehouseStockAvailQtyInput';
    public dataCacheType = (): CacheType => 'none';
}

export interface IGetWarehouseStockAvailQtyData {
    jsonString: number;
}

const createInput = (
    args: ICreateActionContext,
    itemId: string,
    accountNum: number | string,
    itemQuantity: string,
    userName: string
): IActionInput => {
    return new GetWarehouseStockAvailQtyInput(itemId, accountNum, itemQuantity, userName);
};

export async function GetWarehouseStockAvailQty(
    input: GetWarehouseStockAvailQtyInput,
    ctx: IActionContext
): Promise<IGetWarehouseStockAvailQtyResponse> {
    return getWarehouseStockAvailQtyAsync({ callerContext: ctx }, input.itemId, input.accountNum, input.itemQuantity, input.userName)
        .then(data => {
            return data;
        })
        .catch(error => {
            ctx.telemetry.exception(error);
            ctx.trace('[get-warehouse-stock-avail-qty] Unable to load warehouse list');
            throw new Error('[get-warehouse-stock-avail-qty] Unable to load warehouse list');
        });
    // return 999;
}

export default createObservableDataAction({
    action: <IAction<IGetWarehouseStockAvailQtyResponse>>GetWarehouseStockAvailQty,
    id: 'GetWarehouseStockAvailQty',
    input: createInput
});
